/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var AM = "am";
var PM = "pm";
var MERIDIEM_LIST = [AM, PM];
var TIME_PICKER_EMPTY = [void 0, void 0];
var DEFAULT_STEPS = [1, 1, 1];
var DEFAULT_FORMAT = "HH:mm:ss";
var EMPTY_VALUE = -1;
var EPickerCols = /* @__PURE__ */function (EPickerCols2) {
  EPickerCols2["hour"] = "hour";
  EPickerCols2["minute"] = "minute";
  EPickerCols2["second"] = "second";
  EPickerCols2["milliSecond"] = "millisecond";
  EPickerCols2["meridiem"] = "meridiem";
  return EPickerCols2;
}(EPickerCols || {});
var TIME_FORMAT = /(a\s+|A\s+)?(h+|H+)?:?(m+)?:?(s+)?:?(S+)?(\s+a|\s+A)?/;
var PRE_MERIDIEM_FORMAT = /^(a|A)\s+?[h]{1,2}(:[m]{1,2}(:[s]{1,2})?)?$/;
var POST_MERIDIEM_FORMAT = /^[h]{1,2}(:[m]{1,2}(:[s]{1,2})?)?(\s+(a|A))?$/;
var TWELVE_HOUR_FORMAT = /[h]{1}/;
var HM_FORMAT = /[hH]{1,2}:m{1,2}/;
var HMS_FORMAT = /[hH]{1,2}:m{1,2}:s{1,2}/;

export { AM, DEFAULT_FORMAT, DEFAULT_STEPS, EMPTY_VALUE, EPickerCols, HMS_FORMAT, HM_FORMAT, MERIDIEM_LIST, PM, POST_MERIDIEM_FORMAT, PRE_MERIDIEM_FORMAT, TIME_FORMAT, TIME_PICKER_EMPTY, TWELVE_HOUR_FORMAT };
//# sourceMappingURL=const.mjs.map
